export class FeatureDetectionUtils {
  static supportSVG() {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/FeatureDetectionUtils.ts
 **/